import axios from 'axios';
import apiConfig from '../../api.config';

export default function getAccountActiveFunctionalities(hotelIds) {
  const {
    host,
    URIs: { getAccountActiveFunctionalities },
  } = apiConfig;

  const uri = `${host}${getAccountActiveFunctionalities}`;


  return axios
    .post(uri, { hotelIds })
    .then(res => res.data);
}
